import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle_favorite",
  "use": "circle_favorite-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"circle_favorite\">\n<path d=\"M11 6.86022C11.654 6.0297 12.656 5.5 13.7 5.5C15.548 5.5 17 7.07602 17 9.09673C17 11.5621 14.96 13.5828 11.87 16.6368L11 17.5L10.13 16.6368C7.04 13.5828 5 11.5621 5 9.09673C5 7.07602 6.452 5.5 8.3 5.5C9.344 5.5 10.346 6.0297 11 6.86022Z\" fill=\"#BD3636\" />\n<rect x=\"1\" y=\"1\" width=\"20\" height=\"20\" rx=\"10\" stroke=\"#616161\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol